import { ISportFeedResponse } from "@finbackoffice/websocket-client";
import { FC, useContext } from "react";
import { FeedRidContext, useCollapseMargin } from "@finbackoffice/site-core";
import { useSocketStorage } from "hooks";
import PrematchCategoriesContainer from "components/sport/prematch/all/categories/PrematchCategoriesContainer";
import AdvancedSidebarSport from "../../AdvancedSidebarSport";
import styles from "./advanced-sidebar-prematch-sport.module.sass";

type Props = {
    sport: ISportFeedResponse;
    openedByDefault: boolean;
    disableCollapsing?: boolean;
    isSelected?: boolean;
};

const AdvancedSidebarPrematchSport: FC<Props> = ({
    sport,
    openedByDefault,
    disableCollapsing,
    isSelected,
}) => {
    const { prematchRid } = useContext(FeedRidContext);
    const { getCategories } = useSocketStorage(prematchRid);
    const { opened, animating, headerRef, containerRef } = useCollapseMargin(openedByDefault);

    const categories = getCategories(sport.id);

    return (
        <div className={styles.container}>
            <AdvancedSidebarSport
                ref={disableCollapsing ? undefined : headerRef}
                sport={sport}
                opened={opened}
                isSelected={isSelected}
            />
            {(opened || animating) && (
                <PrematchCategoriesContainer
                    categories={categories}
                    sportSlug={sport.slug}
                    ref={containerRef}
                    openedByDefault={openedByDefault}
                    showTournamentCheckbox
                    sportId={sport.id}
                    showArrow={false}
                />
            )}
        </div>
    );
};

export default AdvancedSidebarPrematchSport;
